<template>
    <el-row :gutter="20">
        <el-col :span="24">
            {{ $t("posts.edit.otherInteriorServices") }} :<br>
            <br>
        </el-col>
        <el-col :span="12">
            <el-checkbox v-model="post.acces_wifi" true-label="oui" false-label>
                {{$labels.acces_wifi}}
            </el-checkbox>
        </el-col>
        <el-col :span="12">
            <el-checkbox v-model="post.equipe_congelateur" true-label="oui" false-label>
                {{$labels.equipe_congelateur}}
            </el-checkbox>
        </el-col>
        <el-col :span="12">
            <el-checkbox v-model="post.equipe_four" true-label="oui" false-label>
                {{$labels.equipe_four}}
            </el-checkbox>
        </el-col>
        <el-col :span="12">
            <el-checkbox v-model="post.equipe_microondes" true-label="oui" false-label>
                {{$labels.equipe_microondes}}
            </el-checkbox>
        </el-col>
        <el-col :span="12">
            <el-checkbox v-model="post.equipe_lave_vaisselle" true-label="oui" false-label>
                {{$labels.equipe_lave_vaisselle}}
            </el-checkbox>
        </el-col>
        <el-col :span="12">
            <el-checkbox v-model="post.equipe_lave_linge" true-label="oui" false-label>
                {{$labels.equipe_lave_linge}}
            </el-checkbox>
        </el-col>
        <el-col :span="12">
            <el-checkbox v-model="post.equipe_cafetiere" true-label="oui" false-label>
                {{$labels.equipe_cafetiere}}
            </el-checkbox>
        </el-col>
        <el-col :span="12">
            <el-checkbox v-model="post.equipe_grille_pain" true-label="oui" false-label>
                {{$labels.equipe_grille_pain}}
            </el-checkbox>
        </el-col>
        <el-col :span="12">
            <el-checkbox v-model="post.tv" true-label="oui" false-label>
                {{$labels.tv}}
            </el-checkbox>
        </el-col>
        <el-col :span="12">
            <el-checkbox v-model="post.equipe_fer_repasser" true-label="oui" false-label>
                {{$labels.equipe_fer_repasser}}
            </el-checkbox>
        </el-col>
        <el-col :span="12">
            <el-checkbox v-model="post.avec_linge_maison" true-label="oui" false-label>
                {{$labels.avec_linge_maison}}
            </el-checkbox>
        </el-col>
        <el-col :span="12">
            <el-checkbox v-model="post.local_velos" true-label="oui" false-label>
                {{$labels.local_velos}}
            </el-checkbox>
        </el-col>
        <el-col :span="12">
            <el-checkbox v-model="post.concierge" true-label="oui" false-label>
                {{$labels.concierge}}
            </el-checkbox>
        </el-col>
    </el-row>
</template>

<script>
export default {
  name: 'Colocation',
  props: ['post', 'ddList'],
  data () {
    return {}
  }
}
</script>
